var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"835a0fc36b8deec42b779444d7e8e20bab961732"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs-web3-starterkit@foxlottery"]={id:"835a0fc36b8deec42b779444d7e8e20bab961732"};
      